import styled from 'styled-components';

import { Text } from '@catalyze/ui';

export const ContactSubtitle = styled(Text)`
    font-weight: 400;
    color: ${({ theme }) => theme.colors.fontTertiary};
`;
